/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import { forwardRef } from "react";
import { IconButton } from "../IconButton/IconButton.js";
import { CloseLinear } from "../Iconsax/CloseLinear.js";
import { Tag } from "../Tag/Tag.js";
import { Text } from "../Text/Text.js";
import { TextSize, TextWeight } from "../Text/Text.types.js";
import { SelectedCountWrapper, StyledBulkbar, StyledChildrenWrapper } from "./Bulkbar.style.js";
import { BulkbarProps } from "./Bulkbar.types.js";

export const Bulkbar = forwardRef<HTMLDivElement, BulkbarProps>(
    ({ children, selectedCount, onClose, selectedItemsTitle, noSelectedCountTag, ...props }, ref): JSX.Element => {
        return (
            <StyledBulkbar ref={ref} {...props} className={selectedCount > 0 ? "show" : ""}>
                <div>
                    <IconButton icon={CloseLinear} size="small" onClick={onClose} rounded={false} variant="tinted" color="neutral" />
                    <SelectedCountWrapper>
                        {noSelectedCountTag ? (
                            <Text size={TextSize["X-SMALL"]}>{`${selectedCount} ${selectedItemsTitle || "selected items"}`}</Text>
                        ) : (
                            <Tag textSize={TextSize["X-SMALL"]} textWeight={TextWeight.BOLD}>
                                {`${selectedCount} ${selectedItemsTitle || "selected items"}`}
                            </Tag>
                        )}
                    </SelectedCountWrapper>
                </div>
                <StyledChildrenWrapper>{children}</StyledChildrenWrapper>
            </StyledBulkbar>
        );
    },
);
